document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(
    ".headboard__container, .color__container"
  );

  const mobileHeadbardSelctor = document.querySelector(
    ".headboard__container__mobile"
  );
  const mobileColorSelctor = document.querySelector(
    ".color__container__mobile"
  );

  const upholsteredData = JSON.parse(
    document.querySelector("#upholsteredData").textContent
  );

  const headboardDataInsertContainer = document.querySelector(
    ".headboardDataContainer"
  );
  const colorDataInsertContainer = document.querySelector(
    ".colorDataContainer"
  );
  const drawerDataInsertContainer = document.querySelector(
    ".drawerDataContainer"
  );

  // ------------------------------------
  // DESKTOP TOGGLE LOGIC
  // ------------------------------------
  containers.forEach((container) => {
    const icon = container.querySelector(".animation_prent_pulse");
    const box = container.querySelector(".headboard__data__container");

    box.addEventListener("click", (event) => event.stopPropagation());

    icon.addEventListener("click", (event) => {
      event.stopPropagation();

      const open = box.style.display === "block";

      document.querySelectorAll(".headboard__data__container").forEach((el) => {
        el.style.display = "none";
      });

      box.style.display = open ? "none" : "block";
    });
  });

  document.addEventListener("click", () => {
    document.querySelectorAll(".headboard__data__container").forEach((el) => {
      el.style.display = "none";
    });
  });

  // ------------------------------------
  // MOBILE OPEN DRAWER
  // ------------------------------------
  mobileHeadbardSelctor?.addEventListener("click", () => {
    const heading = mobileHeadbardSelctor.getAttribute("data-title");
    displayDataInDrawer(upholsteredData.headboard, "headboard");
    openDrawer(heading);
  });

  mobileColorSelctor?.addEventListener("click", () => {
    const heading = mobileColorSelctor.getAttribute("data-title");
    displayDataInDrawer(upholsteredData.color, "color");
    openDrawer(heading);
  });

  document
    .querySelectorAll(".comboOffer-close-drawer")
    .forEach((btn) => btn.addEventListener("click", closeDrawer));

  function openDrawer(title) {
    const titleSelector = document.querySelector(".newModularBeds-heading");
    if (titleSelector) titleSelector.textContent = title;

    const drawer = document.querySelector(".comboOffer-drawer-class");
    const overlay = document.querySelector(".comboOffer-custom-overlay");

    drawer?.setAttribute("aria-hidden", "false");
    drawer?.setAttribute("open", "");
    document.body.classList.add("body-scroll-stop");

    overlay?.classList.add("is-visible");
  }

  function closeDrawer() {
    const drawer = document.querySelector(".comboOffer-drawer-class");
    const overlay = document.querySelector(".comboOffer-custom-overlay");

    drawer?.removeAttribute("open");
    drawer?.removeAttribute("aria-hidden");
    document.body.classList.remove("body-scroll-stop");

    overlay?.classList.remove("is-visible");
  }

  // ------------------------------------
  // DISPLAY DATA IN MOBILE DRAWER
  // ------------------------------------
  // function displayDataInDrawer(data) {
  //   if (!drawerDataInsertContainer) return;

  //   drawerDataInsertContainer.innerHTML = "";

  //   const activeTitle = (
  //     upholsteredData.productData.productColor ||
  //     upholsteredData.productData.productHeadboard ||
  //     ""
  //   )
  //     .trim()
  //     .toLowerCase();

  //   data.forEach((item, index) => {
  //     const isActive = item.title.trim().toLowerCase() === activeTitle;

  //     drawerDataInsertContainer.innerHTML += `
  //       <div class="headboard__item"
  //           data-index="${index}"
  //           style="
  //             display:flex;align-items:center;gap:10px;
  //             margin-bottom:10px;padding:10px;border-radius:6px;
  //             cursor:pointer;background:${isActive ? "#ffe5e5" : "transparent"};
  //       ">
  //           <img src="${item.image}" width="100" height="40" style="object-fit:cover;border-radius:6px;width:100px;height:40px;">
  //           <span>${item.title}</span>
  //       </div>
  //     `;
  //   });

  //   const items = drawerDataInsertContainer.querySelectorAll(".headboard__item");

  //   items.forEach((item, index) => {
  //     item.addEventListener("click", () => {
  //       const itemData = data[index];
  //       const clickedTitle = itemData.title.trim().toLowerCase();

  //       if (clickedTitle === activeTitle) return; // ❌ active redirect

  //       window.location.href = itemData.url; // ✔ redirect
  //     });
  //   });
  // }

  const displayDataInDrawer = (data, type) => {
    if (!drawerDataInsertContainer) return;
    drawerDataInsertContainer.innerHTML = "";

    // 💡 SAME ACTIVE LOGIC FOR MOBILE & DESKTOP
    let activeTitle = "";

    if (type === "headboard") {
      activeTitle = upholsteredData.productData.productHeadboard
        ?.trim()
        .toLowerCase();
    } else if (type === "color") {
      activeTitle = upholsteredData.productData.productColor
        ?.trim()
        .toLowerCase();
    }

    data.forEach((item, index) => {
      const isActive = item.title.trim().toLowerCase() === activeTitle;

      drawerDataInsertContainer.innerHTML += `
      <div class="headboard__item" 
          data-index="${index}"
          style="
            display:flex;align-items:center;gap:10px;
            margin-bottom:10px;padding:10px;border-radius:6px;
            cursor:pointer;
            background:${isActive ? "#ffe5e5" : "transparent"};
      ">
          <img src="${
            item.image
          }" width="100" height="50" style="object-fit:cover;border-radius:6px;width:100px;height:50px;">
          <span style="font-weight:${isActive ? "700" : "400"};"> ${item.title} </span>
      </div>
    `;
    });

    const items =
      drawerDataInsertContainer.querySelectorAll(".headboard__item");

    items.forEach((item, index) => {
      item.addEventListener("click", () => {
        const itemData = data[index];
        const clickedTitle = itemData.title.trim().toLowerCase();

        // ❌ ACTIVE ITEM → NO REDIRECT
        if (clickedTitle === activeTitle) return;

        // ✔ NON-ACTIVE ITEM → REDIRECT
        window.location.href = itemData.url;
      });
    });
  };

  // ------------------------------------
  // DESKTOP HEADBOARD
  // ------------------------------------
  function loadHeadboardData(data) {
    if (!headboardDataInsertContainer) return;

    const activeHeadboard = upholsteredData.productData.productHeadboard
      ?.trim()
      .toLowerCase();

    headboardDataInsertContainer.innerHTML = "";

    data.forEach((item, index) => {
      const isActive = item.title.trim().toLowerCase() === activeHeadboard;

      headboardDataInsertContainer.innerHTML += `
        <div class="headboard__item"
            data-index="${index}"
            style="
              display:flex;align-items:center;gap:10px;
              margin-bottom:10px;padding:10px;border-radius:6px;cursor:pointer;
              background:${isActive ? "#ffe5e5" : "transparent"};
        ">
            <img src="${
              item.image
            }" width="100" height="50" style="object-fit:cover;border-radius:6px;width:100px;height:50px;">
            <span style="font-weight:${isActive ? "700" : "400"};"> ${item.title} </span>

        </div>
      `;
    });

    const items =
      headboardDataInsertContainer.querySelectorAll(".headboard__item");

    items.forEach((item, index) => {
      item.addEventListener("click", () => {
        const itemData = data[index];
        const clicked = itemData.title.trim().toLowerCase();

        if (clicked === activeHeadboard) return; // ❌ active redirect off

        window.location.href = itemData.url; // ✔ redirect
      });
    });
  }

  // ------------------------------------
  // DESKTOP COLOR
  // ------------------------------------
  function loadColorData(data) {
    if (!colorDataInsertContainer) return;

    const activeColor = upholsteredData.productData.productColor
      ?.trim()
      .toLowerCase();

    colorDataInsertContainer.innerHTML = "";

    data.forEach((item, index) => {
      const isActive = item.title.trim().toLowerCase() === activeColor;

      colorDataInsertContainer.innerHTML += `
        <div class="headboard__item"
            data-index="${index}"
            style="
              display:flex;align-items:center;gap:10px;
              margin-bottom:10px;padding:10px;border-radius:6px;cursor:pointer;
              background:${isActive ? "#ffe5e5" : "transparent"};
        ">
            <img src="${
              item.image
            }" width="100" height="50" style="object-fit:cover;border-radius:6px;width:100px;height:50px;">
            <span style="font-weight:${isActive ? "700" : "400"};"> ${item.title} </span>

        </div>
      `;
    });

    const items = colorDataInsertContainer.querySelectorAll(".headboard__item");

    items.forEach((item, index) => {
      item.addEventListener("click", () => {
        const itemData = data[index];
        const clicked = itemData.title.trim().toLowerCase();

        if (clicked === activeColor) return; // ❌ active → no redirect

        window.location.href = itemData.url; // ✔ redirect
      });
    });
  }

  

  // ------------------------------------
  // LOAD ON START
  // ------------------------------------
  loadHeadboardData(upholsteredData.headboard);
  loadColorData(upholsteredData.color);
});
